import React from 'react';
import { useTranslation } from 'react-i18next';

import { useClientSpecificVirtualAssistant } from '@hooks/clientSpecificUtils';
import GuideItem from './GuideItem';
import {
  CameraButton,
  ChatButton,
  CommunityButton,
  EventSchedulerButton,
  FullScreenButton,
  MicrophoneButton,
  ReactionsButton,
  ToggleViewButton,
  ToolsButton,
  TeleportButton,
  CollapseExpandButton,
} from './constants';
import UserAvatar from '@components/UserAvatar';
import { useMytaverse } from '@providers/MytaverseProvider';

const useTooltipGuide = () => {
  const { t: translate } = useTranslation();

  const { user } = useMytaverse();
  const assistantData = useClientSpecificVirtualAssistant();

  return {
    Camera: (
      <GuideItem
        label={translate(CameraButton.label)}
        icon={CameraButton.icon}
      />
    ),
    Microphone: (
      <GuideItem
        label={translate(MicrophoneButton.label)}
        icon={MicrophoneButton.icon}
      />
    ),
    ToggleView: (
      <GuideItem
        label={translate(ToggleViewButton.label)}
        icon={ToggleViewButton.icon}
      />
    ),
    Assistant: (
      <GuideItem label={assistantData.label} icon={assistantData.icon} />
    ),
    EventScheduler: (
      <GuideItem
        label={translate(EventSchedulerButton.label)}
        icon={EventSchedulerButton.icon}
      />
    ),
    Chat: (
      <GuideItem label={translate(ChatButton.label)} icon={ChatButton.icon} />
    ),
    Community: (
      <GuideItem
        label={translate(CommunityButton.label)}
        icon={CommunityButton.icon}
      />
    ),
    Tools: (
      <GuideItem label={translate(ToolsButton.label)} icon={ToolsButton.icon} />
    ),
    Reactions: (
      <GuideItem
        label={translate(ReactionsButton.label)}
        icon={ReactionsButton.icon}
      />
    ),
    FullScreen: (
      <GuideItem
        label={translate(FullScreenButton.label)}
        icon={FullScreenButton.icon}
      />
    ),
    Profile: (
      <GuideItem
        label={translate('tooltips.profile')}
        icon={
          <UserAvatar
            src={user.profileImage?.url ?? ''}
            name={user.name || user.email}
          />
        }
      />
    ),
    Teleport: (
      <GuideItem
        label={translate(TeleportButton.label)}
        icon={TeleportButton.icon}
      />
    ),
    CollapseExpand: (
      <GuideItem
        label={translate(CollapseExpandButton.label)}
        icon={CollapseExpandButton.icon}
      />
    ),
    PlaceHolder: <GuideItem />,
  };
};

export default useTooltipGuide;
